import React from "react";

import { Box } from "@mui/material";

import LinearLoading from "root/components/LinearLoading";
import Plug from "root/components/Plugs";
import DataNotLoaded from "root/components/Plugs/DataNotLoaded";

// -------------------------------------------------------------------
const ScrollableChartWrapper = ({
  children,
  isLoading,
  isDataNotLoaded,
  dataNotLoadedText,
  isEmpty,
  emptyText,
  ...rest
}) => {
  return (
    <Box sx={{ position: "relative", overflowX: "auto" }} {...rest}>
      {isLoading ? (
        <LinearLoading />
      ) : isDataNotLoaded ? (
        <DataNotLoaded text={dataNotLoadedText} />
      ) : isEmpty ? (
        <Plug text={emptyText} />
      ) : null}
      {children}
    </Box>
  );
};

export default ScrollableChartWrapper;
